<template>
    <div>
        <webix-ui :config="ui" v-model="user_data"></webix-ui>
        <div id="userAdminTablePaging"></div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import { adminComputed, adminMethods, userAdministrationComputed, userAdministrationMethods } from "@/state/helpers";

export default {
    components: {},
    data: () => ({
        resize_event: null,
        // user_data: [
        //     { id: 1, name: "Jack", role: "Admin", email: "jack@email.com" },
        //     { id: 2, name: "Jill", role: "Team member", email: "jill@email.com" },
        // ],
    }),
    computed: {
        ...userAdministrationComputed,
        ...adminComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "userAdminTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "row",
                // hover: "userAdminTableHoverRow",

                minHeight: 60,
                minColumnWidth: 120,
                rowHeight: 35,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                editable: true,

                // pager: {
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "userAdminTablePaging",
                //     css: { width: "100% !important" },
                //     size: 15,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "actions",
                        // header: [{ content: "masterCheckbox" }],
                        header: { text: "Actions", css: { "text-align": "center" } },
                        template: function(obj) {
                            if (el.user_id == obj.id) {
                                return `
                                    <div class="tableIcons">
                                        <i v-b-tooltip.hover title="Permissions" class="mdi mdi-lock-open-check viewAction"></i>
                                        <i v-b-tooltip.hover title="Edit Team Member" class="mdi mdi-account-edit editAction"></i>
                                        <i v-b-tooltip.hover title="Delete Team Member" class="bx bx-trash deleteAction deleteAction change-visiblity"></i>
                                    </div>`;
                            }

                            return `
                        <div class="tableIcons">
                            <i v-b-tooltip.hover title="Permissions" class="mdi mdi-lock-open-check viewAction"></i>
                            <i v-b-tooltip.hover title="Edit Team Member" class="mdi mdi-account-edit editAction"></i>
                            <i v-b-tooltip.hover title="Delete Team Member" class="bx bx-trash deleteAction deleteAction"></i>
                        </div>`;
                        },
                        // maxWidth: 85,
                        css: { "text-align": "center" },
                    },
                    {
                        id: "username",
                        header: ["Name", { content: "textFilter" }],
                        tooltip: false,
                        // editor: "text",
                        // fillspace: 1,
                        template: function(obj) {
                            // obj.name;
                            return "<div class='userAdminTable-pointer  viewAction'>" + obj.first_name + " " + obj.last_name + " </div>";
                        },
                        sort: "string",
                        width: 200,
                    },
                    // {
                    //     id: "role",
                    //     header: "Role",
                    //     tooltip: false,
                    //     // editor: "text",
                    //     fillspace: 1,
                    // },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        tooltip: false,
                        // editor: "text",
                        fillspace: 1,
                        sort: "string",
                    },
                ],
                ready() {
                    // el.resize_event = window.webix.event(window, "resize", function() {
                    //     el.$nextTick(() => {
                    //         window.webix.$$(el.ui.id).refresh();
                    //     });
                    // });
                },
                on: {
                    //eslint-disable-next-line
                    // onItemClick(id, e, node) {
                    //     const userId = this.getItem(id);
                    //     //eslint-disable-next-line
                    //     // console.log("This row was clicked", id, iD);
                    //     el.setSelectedUser(userId);
                    //     el.$router.push({
                    //         path: `/user-administration/${userId.id}`,
                    //     });
                    // },
                },

                onClick: {
                    //eslint-disable-next-line
                    viewAction: function(id, e, trg) {
                        var el = this.$scope.$parent;
                        //el.$emit('editSupplier', e.row);
                        const userId = this.getItem(e.row);
                        //eslint-disable-next-line
                        console.log("the user details", userId, id);
                        //eslint-disable-next-line
                        // console.log("This row was clicked", id, iD);
                        el.setSelectedUser(userId);
                        el.$router.push({
                            path: `/user-administration/${userId.id}`,
                        });
                    }, //eslint-disable-next-line
                    deleteAction: function(id, e, trg) {
                        //eslint-disable-next-line
                        const el = this.$scope.$parent;
                        //eslint-disable-next-line
                        const item = this.getItem(e.row);

                        el.handleSwal(item);
                    },
                    //eslint-disable-next-line
                    editAction: function(id, e, trf) {
                        //eslint-disable-next-line
                        const el = this.$scope.$parent;
                        //get the table rows details
                        // el.setSelectedUserToEdit(this.getItem(e.row));
                        const user = this.getItem(e.row);
                        el.setSelectedUser(user);
                        //eslint-disable-next-line
                        // console.log("the user details", user);
                        // el.editUser();
                        el.$emit("handleModal", "editTeamMemberModal");
                    },
                },
            };

            //pager
            if (this.user_data.length > 15) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "userAdminTablePaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                };
            }
            return ui;
        },
    },
    methods: {
        ...adminMethods,
        ...userAdministrationMethods,
        handleSwal(item) {
            Swal.fire({
                title: ` Delete Team Member `,
                text: `Delete ${item.username} ?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.deleteTeamMember({ user_id: item.id }).then(() => {
                        Swal.fire(`Team Member Deleted`, "", "success");

                        this.setUsersForPermissions();

                        this.closeModal();
                    });
                }
            });
        },
    },
    mounted() {
        this.setUsersForPermissions();
    },
    beforeDestroy() {
        this.setSelectedUser(null);
    },
};
</script>

<style lang="scss">
.userAdminTable-pointer {
    cursor: pointer;
}
.userAdminTableHoverRow {
    background: #f0dcb6;
    // cursor: pointer;
}
.change-visiblity {
    visibility: hidden;
}
</style>
